import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    state() {
        return {
            userId: (localStorage.getItem('userId')!='')?localStorage.getItem('userId'):null,
            token: (localStorage.getItem('token')!='')?localStorage.getItem('token'):null,
            didAutoLogout: false
        };
    },
    mutations,
    actions,
    getters
};